import React, { useEffect, useState } from "react";
import MainLayout from "../layout/MainLayout";
import { hasPermission } from "../utils/permissions";
import { API_BASE } from "../config/orbisConfig";



function GridRowsProStyle() {
    return (
        <style>{`
            .grid-rows-pro table tbody tr {
                transition: background 0.18s ease;
            }
            .grid-rows-pro table tbody tr:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro table tbody tr:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro table tbody tr:hover {
                background: #eff6ff !important;
            }
            .grid-rows-pro table tbody td {
                font-size: 14px;
                color: #111827;
                vertical-align: top;
            }
            .grid-rows-pro table tbody td .grid-row-main {
                font-weight: 700;
                color: #111827;
            }
            .grid-rows-pro table tbody td .grid-row-sub {
                color: #6b7280;
                font-size: 12px;
            }
            .grid-rows-pro ul.grid-hover-list > li {
                transition: background 0.18s ease;
            }
            .grid-rows-pro ul.grid-hover-list > li:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro ul.grid-hover-list > li:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro ul.grid-hover-list > li:hover {
                background: #eff6ff !important;
            }
        `}</style>
    );
}


function authHeaders(extra = {}) {
    const token = localStorage.getItem("cani_auth") || "";
    return {
        ...extra,
        Authorization: "Bearer " + token,
        "X-CANI-AUTH": token,
    };
}

const affiliationsStatusLabels = {
    prospecto: "Prospecto",
    contactado: "Contactado",
    registro_iniciado: "Registro iniciado",
    afiliado: "Afiliado (sin pago)",
    afiliado_pago_pendiente: "Afiliado (pago pendiente)",
    afiliado_activo: "Afiliado activo",
    baja: "Baja",
};

const paymentStatusLabels = {
    no_aplica: "No aplica",
    pendiente: "Pendiente",
    pagado: "Pagado",
    vencido: "Vencido",
};

const AffiliationsPage = () => {
    const canCreate = hasPermission("affiliations.create");
    const canEdit = hasPermission("affiliations.edit");
    const canDelete = hasPermission("affiliations.delete");

    const [affiliations, setAffiliations] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [industries, setIndustries] = useState([]);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const [filterStatus, setFilterStatus] = useState("todos");
    const [filterIndustry, setFilterIndustry] = useState("todos");
    const [searchTerm, setSearchTerm] = useState("");

    const [showForm, setShowForm] = useState(false);
    const [formMode, setFormMode] = useState("create");
    const [editingId, setEditingId] = useState(null);

    const [selectedAffiliation, setSelectedAffiliation] = useState(null);
    const [activities, setActivities] = useState([]);
    const [activityForm, setActivityForm] = useState({
        type: "email_enviado",
        channel: "email",
        subject: "",
        description: "",
    });
    const [savingActivity, setSavingActivity] = useState(false);

    const [form, setForm] = useState({
        account_id: "",
        main_contact_id: "",
        industry_id: "",
        section: "",
        status: "prospecto",
        platform_registered: false,
        payment_status: "pendiente",
        notes: "",
    });

    useEffect(() => {
        const fetchAll = async () => {
            try {
                setLoading(true);
                setError("");

                const [accRes, affRes, conRes, indRes] = await Promise.all([
                    fetch(API_BASE + "/accounts_list.php", { headers: authHeaders() }),
                    fetch(API_BASE + "/affiliations_list.php", { headers: authHeaders() }),
                    fetch(API_BASE + "/contacts_list.php", { headers: authHeaders() }),
                    fetch(API_BASE + "/industries_list.php", { headers: authHeaders() }),
                ]);

                const accData = await accRes.json().catch(() => []);
                const affData = await affRes.json().catch(() => []);
                const conData = await conRes.json().catch(() => []);
                const indData = await indRes.json().catch(() => []);

                setAccounts(Array.isArray(accData) ? accData : []);
                setAffiliations(Array.isArray(affData) ? affData : []);
                setContacts(Array.isArray(conData) ? conData : []);
                setIndustries(Array.isArray(indData) ? indData : []);
            } catch (err) {
                console.error(err);
                setError("No se pudieron cargar las afiliaciones.");
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, []);

    const resetForm = () => {
        setForm({
            account_id: "",
            main_contact_id: "",
            industry_id: "",
            section: "",
            status: "prospecto",
            platform_registered: false,
            payment_status: "pendiente",
            notes: "",
        });
        setEditingId(null);
        setFormMode("create");
    };

    const handleNew = () => {
        if (!canCreate) return;
        resetForm();
        setShowForm(true);
    };

    const handleEdit = (aff) => {
        if (!canEdit) return;

        setForm({
            account_id: aff.account_id || "",
            main_contact_id: aff.main_contact_id || "",
            industry_id: aff.industry_id || "",
            section: aff.section || "",
            status: aff.status || "prospecto",
            platform_registered:
                aff.platform_registered === 1 || aff.platform_registered === "1",
            payment_status: aff.payment_status || "pendiente",
            notes: aff.notes || "",
        });
        setEditingId(aff.id);
        setFormMode("edit");
        setShowForm(true);
        setSelectedAffiliation(aff);
        loadActivities(aff.id);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!form.account_id) {
            setError("Selecciona una empresa (cuenta) para la afiliación.");
            return;
        }

        if (formMode === "create" && !canCreate) {
            setError("No tienes permiso para crear afiliaciones.");
            return;
        }

        if (formMode === "edit" && !canEdit) {
            setError("No tienes permiso para editar afiliaciones.");
            return;
        }

        try {
            setSaving(true);
            const payload = {
                ...form,
                platform_registered: form.platform_registered ? 1 : 0,
            };

            let url = "";
            if (formMode === "create") {
                url = API_BASE + "/affiliation_create.php";
            } else {
                url = API_BASE + "/affiliation_update.php";
                payload.id = editingId;
            }

            const res = await fetch(url, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok || data.success === false || data.ok === false) {
                throw new Error(
                    data.error || "No se pudo guardar la afiliación. Verifica los datos."
                );
            }

            const affRes = await fetch(API_BASE + "/affiliations_list.php", {
                headers: authHeaders(),
            });
            const affData = await affRes.json().catch(() => []);
            setAffiliations(Array.isArray(affData) ? affData : []);

            setShowForm(false);
            resetForm();
            alert("Afiliación guardada correctamente.");
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al guardar la afiliación.");
        } finally {
            setSaving(false);
        }
    };

    const loadActivities = async (affiliationId) => {
        try {
            const res = await fetch(
                API_BASE + "/affiliation_activities_list.php?affiliation_id=" + affiliationId,
                { headers: authHeaders() }
            );
            const data = await res.json().catch(() => []);
            setActivities(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error(err);
        }
    };

    const handleSelectAffiliationRow = (aff) => {
        setSelectedAffiliation(aff);
        loadActivities(aff.id);
    };

    const handleActivityChange = (e) => {
        const { name, value } = e.target;
        setActivityForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleActivitySubmit = async (e) => {
        e.preventDefault();
        if (!selectedAffiliation) return;

        if (!canEdit) {
            alert("No tienes permiso para registrar actividades en afiliaciones.");
            return;
        }

        try {
            setSavingActivity(true);
            const payload = {
                affiliation_id: selectedAffiliation.id,
                ...activityForm,
            };

            const res = await fetch(API_BASE + "/affiliation_activity_create.php", {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok || data.success === false || data.ok === false) {
                throw new Error(data.error || "No se pudo guardar la actividad.");
            }

            setActivityForm({
                type: "email_enviado",
                channel: "email",
                subject: "",
                description: "",
            });

            await loadActivities(selectedAffiliation.id);
        } catch (err) {
            console.error(err);
            alert(err.message || "Error al guardar la actividad.");
        } finally {
            setSavingActivity(false);
        }
    };

    const getAccountName = (account_id) => {
        const a = accounts.find((acc) => String(acc.id) === String(account_id));
        return a ? a.name : "-";
    };

    const getContactName = (contact_id) => {
        const c = contacts.find((ct) => String(ct.id) === String(contact_id));
        return c ? `${c.first_name} ${c.last_name}` : "-";
    };

    const getIndustryName = (industry_id) => {
        const ind = industries.find((i) => String(i.id) === String(industry_id));
        return ind ? ind.name : "-";
    };

    const statusCounts = affiliations.reduce((acc, aff) => {
        const st = aff.status || "prospecto";
        acc[st] = (acc[st] || 0) + 1;
        return acc;
    }, {});

    const totalAfiliadosActivos = statusCounts["afiliado_activo"] || 0;
    const totalPagoPendiente = statusCounts["afiliado_pago_pendiente"] || 0;

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    const afiliadosActivosMes = affiliations.filter((aff) => {
        if (aff.status !== "afiliado_activo") return false;
        if (!aff.created_at) return false;
        const dt = new Date(String(aff.created_at).replace(" ", "T"));
        if (Number.isNaN(dt.getTime())) return false;
        return dt.getFullYear() === currentYear && dt.getMonth() === currentMonth;
    }).length;

    const normalizedSearch = searchTerm.trim().toLowerCase();

    const filteredAffiliations = affiliations.filter((aff) => {
        const okStatus = filterStatus === "todos" || aff.status === filterStatus;
        const okIndustry =
            filterIndustry === "todos" ||
            String(aff.industry_id) === String(filterIndustry);

        if (!normalizedSearch) return okStatus && okIndustry;

        const accountName = (getAccountName(aff.account_id) || "").toLowerCase();
        const contactName = (getContactName(aff.main_contact_id) || "").toLowerCase();

        const okSearch =
            accountName.includes(normalizedSearch) ||
            contactName.includes(normalizedSearch);

        return okStatus && okIndustry && okSearch;
    });

    return (
        <MainLayout>
            <GridRowsProStyle />
            <div className="p-4 space-y-4 grid-rows-pro">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <div>
                        <h2 className="text-lg md:text-xl font-semibold text-cani-dark">
                            Afiliaciones CANIETI
                        </h2>
                        <p className="text-xs md:text-sm text-gray-500">
                            Gestión diaria de empresas que se afilian a CANIETI: desde el
                            primer contacto hasta el pago y activación.
                        </p>
                    </div>
                    {canCreate ? (
                        <button
                            type="button"
                            onClick={handleNew}
                            className="px-3 py-1.5 rounded-lg bg-cani-primary text-white text-xs hover:bg-cani-primaryLight"
                        >
                            + Nueva afiliación
                        </button>
                    ) : null}
                </div>

                {error && (
                    <div className="mb-2 text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                        {error}
                    </div>
                )}

                <div className="bg-white border border-cani-border rounded-xl shadow-sm p-3 text-[11px] space-y-2">
                    <div className="flex flex-wrap gap-2 items-center justify-between">
                        <span className="font-semibold text-cani-dark">Filtros de vista</span>
                        <span className="text-gray-500">
                            Mostrando {filteredAffiliations.length} de {affiliations.length} afiliaciones
                        </span>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
                        <div>
                            <label className="block text-gray-600 mb-1">Estado</label>
                            <select
                                value={filterStatus}
                                onChange={(e) => setFilterStatus(e.target.value)}
                                className="w-full border border-cani-border rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                            >
                                <option value="todos">Todos</option>
                                {Object.keys(affiliationsStatusLabels).map((st) => (
                                    <option key={st} value={st}>
                                        {affiliationsStatusLabels[st]}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-gray-600 mb-1">Eje / industria</label>
                            <select
                                value={filterIndustry}
                                onChange={(e) => setFilterIndustry(e.target.value)}
                                className="w-full border border-cani-border rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                            >
                                <option value="todos">Todos</option>
                                {industries.map((i) => (
                                    <option key={i.id} value={i.id}>
                                        {i.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="md:col-span-2">
                            <label className="block text-gray-600 mb-1">
                                Buscar (empresa o contacto)
                            </label>
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Ej. Peñoles, CANIETI, proveedor TI…"
                                className="w-full border border-cani-border rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                            />
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2 text-[10px]">
                    {Object.keys(affiliationsStatusLabels).map((st) => (
                        <div
                            key={st}
                            className="bg-white border border-cani-border rounded-xl shadow-sm p-2 flex flex-col justify-between"
                        >
                            <div className="text-gray-500">{affiliationsStatusLabels[st]}</div>
                            <div className="text-lg font-semibold text-cani-dark mt-1">
                                {statusCounts[st] || 0}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-[10px]">
                    <div className="bg-white border border-cani-border rounded-xl shadow-sm p-3">
                        <div className="text-gray-500">Afiliados activos</div>
                        <div className="text-2xl font-semibold text-cani-dark mt-1">
                            {totalAfiliadosActivos}
                        </div>
                    </div>
                    <div className="bg-white border border-cani-border rounded-xl shadow-sm p-3">
                        <div className="text-gray-500">Pago pendiente</div>
                        <div className="text-2xl font-semibold text-cani-dark mt-1">
                            {totalPagoPendiente}
                        </div>
                    </div>
                    <div className="bg-white border border-cani-border rounded-xl shadow-sm p-3">
                        <div className="text-gray-500">Nuevos activos este mes</div>
                        <div className="text-2xl font-semibold text-cani-dark mt-1">
                            {afiliadosActivosMes}
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                    <div className="lg:col-span-2 bg-white border border-cani-border rounded-xl shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b border-cani-border flex items-center justify-between">
                            <div>
                                <h3 className="text-xs font-semibold text-cani-dark">Afiliaciones</h3>
                                <p className="text-[10px] text-gray-500">
                                    Empresas, contactos y estado actual del proceso de afiliación.
                                </p>
                            </div>
                            <span className="text-[11px] text-gray-500">
                                Total filtradas: {filteredAffiliations.length}
                            </span>
                        </div>

                        <div className="max-h-[60vh] overflow-y-auto">
                            <table className="min-w-full text-xs">
                                <thead className="bg-cani-bg">
                                    <tr className="text-left text-[11px] font-semibold text-gray-600">
                                        <th className="px-3 py-2">Empresa</th>
                                        <th className="px-3 py-2 hidden md:table-cell">Contacto</th>
                                        <th className="px-3 py-2 hidden lg:table-cell">Eje / Industria</th>
                                        <th className="px-3 py-2 hidden md:table-cell">Estado</th>
                                        <th className="px-3 py-2 hidden md:table-cell">Pago</th>
                                        <th className="px-3 py-2 text-right">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading && (
                                        <tr>
                                            <td colSpan={6} className="px-3 py-4 text-center text-gray-500">
                                                Cargando afiliaciones...
                                            </td>
                                        </tr>
                                    )}

                                    {!loading && filteredAffiliations.length === 0 && (
                                        <tr>
                                            <td colSpan={6} className="px-3 py-4 text-center text-gray-400">
                                                No hay afiliaciones que cumplan con los filtros seleccionados.
                                            </td>
                                        </tr>
                                    )}

                                    {!loading &&
                                        filteredAffiliations.map((aff) => (
                                            <tr
                                                key={aff.id}
                                                className={`border-t border-cani-border hover:bg-cani-bg/60 cursor-pointer ${selectedAffiliation && selectedAffiliation.id === aff.id
                                                    ? "bg-cani-bg/80"
                                                    : ""
                                                    }`}
                                                onClick={() => handleSelectAffiliationRow(aff)}
                                            >
                                                <td className="px-3 py-2 text-[11px] text-cani-dark">
                                                    <div className="font-medium">{getAccountName(aff.account_id)}</div>
                                                    {aff.section && (
                                                        <div className="text-[10px] text-gray-500">
                                                            Sección: {aff.section}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="px-3 py-2 hidden md:table-cell text-[11px] text-gray-600">
                                                    {getContactName(aff.main_contact_id)}
                                                </td>
                                                <td className="px-3 py-2 hidden lg:table-cell text-[11px] text-gray-600">
                                                    {getIndustryName(aff.industry_id)}
                                                </td>
                                                <td className="px-3 py-2 hidden md:table-cell text-[11px] text-gray-600">
                                                    {affiliationsStatusLabels[aff.status] || aff.status}
                                                </td>
                                                <td className="px-3 py-2 hidden md:table-cell text-[11px] text-gray-600">
                                                    {paymentStatusLabels[aff.payment_status] || aff.payment_status}
                                                </td>
                                                <td className="px-3 py-2 text-right text-[11px] text-gray-600">
                                                    {canEdit ? (
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleEdit(aff);
                                                            }}
                                                            className="px-2 py-1 rounded-lg border border-cani-border hover:bg-cani-bg"
                                                        >
                                                            Editar
                                                        </button>
                                                    ) : null}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="bg-white border border-cani-border rounded-xl shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b border-cani-border">
                            <h3 className="text-xs font-semibold text-cani-dark">
                                Detalle y actividades
                            </h3>
                            <p className="text-[10px] text-gray-500">
                                Selecciona una afiliación para ver y registrar emails, llamadas,
                                documentos, etc.
                            </p>
                        </div>

                        {!selectedAffiliation ? (
                            <div className="px-4 py-6 text-center text-xs text-gray-400">
                                Selecciona una afiliación de la lista para ver sus actividades.
                            </div>
                        ) : (
                            <div className="flex flex-col h-full">
                                <div className="px-4 py-3 border-b border-cani-border text-[11px] space-y-1">
                                    <div className="font-semibold text-cani-dark">
                                        {getAccountName(selectedAffiliation.account_id)}
                                    </div>
                                    <div className="text-gray-600">
                                        Contacto: {getContactName(selectedAffiliation.main_contact_id)}
                                    </div>
                                    <div className="text-gray-600">
                                        Estado:{" "}
                                        {affiliationsStatusLabels[selectedAffiliation.status] ||
                                            selectedAffiliation.status}
                                    </div>
                                    <div className="text-gray-600">
                                        Pago:{" "}
                                        {paymentStatusLabels[selectedAffiliation.payment_status] ||
                                            selectedAffiliation.payment_status}
                                    </div>
                                </div>

                                <div className="flex-1 max-h-[40vh] overflow-y-auto">
                                    {activities.length === 0 ? (
                                        <div className="px-4 py-4 text-center text-[11px] text-gray-400">
                                            Aún no hay actividades registradas para esta afiliación.
                                        </div>
                                    ) : (
                                        <ul className="divide-y divide-cani-border text-[11px]">
                                            {activities.map((act) => (
                                                <li key={act.id} className="px-4 py-3">
                                                    <div className="flex justify-between gap-2">
                                                        <div>
                                                            <div className="font-semibold text-cani-dark">
                                                                {act.type} ({act.channel})
                                                            </div>
                                                            {act.subject && (
                                                                <div className="text-gray-700">{act.subject}</div>
                                                            )}
                                                            {act.description && (
                                                                <div className="text-[10px] text-gray-600 mt-1">
                                                                    {act.description}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="text-right text-[10px] text-gray-500">
                                                            {act.user_name && <div>{act.user_name}</div>}
                                                            <div>{act.created_at}</div>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>

                                <div className="border-t border-cani-border px-4 py-3 text-[11px]">
                                    <div className="font-semibold text-cani-dark mb-1">
                                        Nueva actividad
                                    </div>

                                    {canEdit ? (
                                        <form onSubmit={handleActivitySubmit} className="space-y-2">
                                            <div className="grid grid-cols-2 gap-2">
                                                <div>
                                                    <label className="block text-gray-600 mb-1">Tipo</label>
                                                    <select
                                                        name="type"
                                                        value={activityForm.type}
                                                        onChange={handleActivityChange}
                                                        className="w-full border border-cani-border rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                    >
                                                        <option value="email_enviado">Email enviado</option>
                                                        <option value="email_recibido">Email recibido</option>
                                                        <option value="llamada">Llamada</option>
                                                        <option value="whatsapp">WhatsApp</option>
                                                        <option value="reunion">Reunión</option>
                                                        <option value="documento_enviado">Documento enviado</option>
                                                        <option value="documento_recibido">Documento recibido</option>
                                                        <option value="otro">Otro</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label className="block text-gray-600 mb-1">Canal</label>
                                                    <select
                                                        name="channel"
                                                        value={activityForm.channel}
                                                        onChange={handleActivityChange}
                                                        className="w-full border border-cani-border rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                    >
                                                        <option value="email">Email</option>
                                                        <option value="telefono">Teléfono</option>
                                                        <option value="whatsapp">WhatsApp</option>
                                                        <option value="presencial">Presencial</option>
                                                        <option value="plataforma">Plataforma</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div>
                                                <label className="block text-gray-600 mb-1">
                                                    Asunto / resumen
                                                </label>
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    value={activityForm.subject}
                                                    onChange={handleActivityChange}
                                                    className="w-full border border-cani-border rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-gray-600 mb-1">Detalle</label>
                                                <textarea
                                                    name="description"
                                                    value={activityForm.description}
                                                    onChange={handleActivityChange}
                                                    rows={2}
                                                    className="w-full border border-cani-border rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary resize-none"
                                                    placeholder="Qué se habló, qué se acordó, próximos pasos..."
                                                />
                                            </div>

                                            <div className="flex justify-end">
                                                <button
                                                    type="submit"
                                                    disabled={savingActivity}
                                                    className="px-3 py-1.5 rounded-lg bg-cani-primary text-white text-[11px] hover:bg-cani-primaryLight disabled:opacity-60"
                                                >
                                                    {savingActivity ? "Guardando..." : "Agregar actividad"}
                                                </button>
                                            </div>
                                        </form>
                                    ) : (
                                        <div className="text-[11px] text-gray-400">
                                            No tienes permiso para agregar actividades.
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {showForm && (
                    <div className="bg-white border border-cani-border rounded-xl shadow-sm p-4 text-xs space-y-3">
                        <div className="flex items-center justify-between gap-2">
                            <div>
                                <h3 className="text-[12px] font-semibold text-cani-dark">
                                    {formMode === "create" ? "Nueva afiliación" : "Editar afiliación"}
                                </h3>
                                <p className="text-[11px] text-gray-500">
                                    Registra la empresa, contacto principal, eje y estado del proceso.
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={() => {
                                    setShowForm(false);
                                    resetForm();
                                }}
                                className="text-[11px] text-gray-500 hover:text-gray-700"
                            >
                                Cerrar ✕
                            </button>
                        </div>

                        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div className="space-y-2">
                                <div>
                                    <label className="block text-[11px] text-gray-600 mb-1">
                                        Empresa (cuenta) *
                                    </label>
                                    <select
                                        name="account_id"
                                        value={form.account_id}
                                        onChange={handleChange}
                                        className="w-full border border-cani-border rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                        required
                                    >
                                        <option value="">-- Selecciona empresa --</option>
                                        {accounts.map((a) => (
                                            <option key={a.id} value={a.id}>
                                                {a.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-[11px] text-gray-600 mb-1">
                                        Contacto principal
                                    </label>
                                    <select
                                        name="main_contact_id"
                                        value={form.main_contact_id}
                                        onChange={handleChange}
                                        className="w-full border border-cani-border rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                    >
                                        <option value="">-- Selecciona contacto --</option>
                                        {contacts
                                            .filter(
                                                (c) =>
                                                    !form.account_id ||
                                                    String(c.account_id) === String(form.account_id)
                                            )
                                            .map((c) => (
                                                <option key={c.id} value={c.id}>
                                                    {c.first_name} {c.last_name} ({getAccountName(c.account_id)})
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-[11px] text-gray-600 mb-1">
                                        Eje / industria
                                    </label>
                                    <select
                                        name="industry_id"
                                        value={form.industry_id}
                                        onChange={handleChange}
                                        className="w-full border border-cani-border rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                    >
                                        <option value="">-- Selecciona eje --</option>
                                        {industries.map((i) => (
                                            <option key={i.id} value={i.id}>
                                                {i.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-[11px] text-gray-600 mb-1">
                                        Sección / segmento
                                    </label>
                                    <input
                                        type="text"
                                        name="section"
                                        value={form.section}
                                        onChange={handleChange}
                                        className="w-full border border-cani-border rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                        placeholder="Ej. Startups TI, Gobierno, Universidad…"
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <div className="grid grid-cols-2 gap-2">
                                    <div>
                                        <label className="block text-[11px] text-gray-600 mb-1">
                                            Estado
                                        </label>
                                        <select
                                            name="status"
                                            value={form.status}
                                            onChange={handleChange}
                                            className="w-full border border-cani-border rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                        >
                                            {Object.keys(affiliationsStatusLabels).map((st) => (
                                                <option key={st} value={st}>
                                                    {affiliationsStatusLabels[st]}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-[11px] text-gray-600 mb-1">
                                            Pago
                                        </label>
                                        <select
                                            name="payment_status"
                                            value={form.payment_status}
                                            onChange={handleChange}
                                            className="w-full border border-cani-border rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                        >
                                            {Object.keys(paymentStatusLabels).map((ps) => (
                                                <option key={ps} value={ps}>
                                                    {paymentStatusLabels[ps]}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="flex items-center gap-2 mt-1">
                                    <input
                                        type="checkbox"
                                        id="platform_registered"
                                        name="platform_registered"
                                        checked={form.platform_registered}
                                        onChange={handleChange}
                                        className="h-3 w-3"
                                    />
                                    <label
                                        htmlFor="platform_registered"
                                        className="text-[11px] text-gray-600"
                                    >
                                        Ya inició registro en la plataforma de afiliaciones
                                    </label>
                                </div>

                                <div>
                                    <label className="block text-[11px] text-gray-600 mb-1">
                                        Notas
                                    </label>
                                    <textarea
                                        name="notes"
                                        value={form.notes}
                                        onChange={handleChange}
                                        rows={3}
                                        className="w-full border border-cani-border rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-cani-primary resize-none"
                                        placeholder="Información relevante del proceso: acuerdos, condiciones especiales, etc."
                                    />
                                </div>

                                <div className="flex justify-end gap-2 pt-1">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowForm(false);
                                            resetForm();
                                        }}
                                        className="px-3 py-1.5 rounded-lg border border-cani-border text-gray-700 text-xs hover:bg-cani-bg"
                                    >
                                        Cancelar
                                    </button>

                                    {((formMode === "create" && canCreate) ||
                                        (formMode === "edit" && canEdit)) ? (
                                        <button
                                            type="submit"
                                            disabled={saving}
                                            className="px-3 py-1.5 rounded-lg bg-cani-primary text-white text-xs hover:bg-cani-primaryLight disabled:opacity-60"
                                        >
                                            {saving
                                                ? "Guardando..."
                                                : formMode === "create"
                                                    ? "Crear afiliación"
                                                    : "Guardar cambios"}
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                        </form>
                    </div>
                )}
            </div>
        </MainLayout>
    );
};

export default AffiliationsPage;
